export enum TimePreference {
  Call = 'call',
  Offer = 'offer',
  Custom = 'custom',
}
